import {User} from '../models/user';
import {EventEmitter, Injectable, Output} from '@angular/core';
import {Role} from '../models/Role.enum';
import {Router} from '@angular/router';
import {AngularFireAuth} from 'angularfire2/auth';
import {UserRepo} from "../DAL/usersRepo";

@Injectable()
export class UserHelper {
  private static currentUser: User;

  private userInfo = 'roche:USERINFO';

  @Output()
  regionChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  userChanged: EventEmitter<User> = new EventEmitter<User>();

  constructor(private router: Router, private af: AngularFireAuth, private userRepo: UserRepo) {
    if (UserHelper.currentUser) {
      return;
    }
    const data = localStorage.getItem(this.userInfo);
    if (data) {
      const userInfo = JSON.parse(data);
      UserHelper.currentUser = userInfo;
      UserHelper.currentUser.role = Role[userInfo.role + ''];
    } else {
      localStorage.clear();
      this.router.navigateByUrl('/auth/login');
    }
  }

  getUser(): User {
    return UserHelper.currentUser;
  }

  getUserFullName(): string{
    return `${UserHelper.currentUser.firstname} ${UserHelper.currentUser.lastname}`;
  }

  getUserToken(): Promise<string> {
    return new Promise((resolve) => {
      const subscribed = this.af.authState.subscribe(async user => {
        subscribed.unsubscribe();
        const token = await user.getToken();
        return resolve(token);
      });
    });
  }

  isAdmin(): boolean {
    return UserHelper.currentUser.role === Role.admin;
  }

  setUser(user: any) {
    UserHelper.currentUser = user;
    localStorage.setItem(this.userInfo, JSON.stringify(user));
    UserHelper.currentUser.role = Role[user.role + ''];
    this.userChanged.emit(UserHelper.currentUser);
  }

  updateCurrentUser() {
     this.userRepo.getCurrentUser().then((u) => this.setUser(u));
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/utils/UserHelper.ts